import apiClient from "@/api/apiClient";
import type { PaginatedDeviceTag } from "@/api/resources/deviceTags/types";
import {
  spawnCreateApiFunction,
  spawnDeleteApiFunction,
  spawnGetApiFunction,
  spawnListApiFunction,
  spawnUpdateApiFunction,
  type ApiResourceConfig,
} from "@/utils/api";

const table = "device_tags";
const query = `
                *,
                devices(
                  id,
                  name
                ),
                search_d:devices(name)
              `;
export const apiConfigDeviceTags: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: ["name", "description", "search_d.name"],
  sortables: ["name", "updated_at", "created_at"],
};

export const getDeviceTags = spawnListApiFunction({ table, query });
export const getDeviceTag = spawnGetApiFunction({ table, query });
export const createDeviceTag = spawnCreateApiFunction({ table, query });
export const updateDeviceTag = spawnUpdateApiFunction({ table, query });
export const deleteDeviceTag = spawnDeleteApiFunction({ table });

export const getDeviceTagChildren = async (
  workspace_ids: string[],
  device_tag_id?: string,
): Promise<PaginatedDeviceTag[]> => {
  const q = apiClient.from(table).select(query).in("workspace_id", workspace_ids);
  if (!device_tag_id) q.is("parent_device_tag_id", null);
  else q.eq("parent_device_tag_id", device_tag_id);
  const { data, error } = await q;
  if (error) return [];
  return data;
};
